<template>
    <div class="wrapper">
        <header class="main-header">
            <!-- Logo -->
            <a href="/" class="logo">
                <!-- mini logo for sidebar mini 50x50 pixels -->
                <span class="logo-mini">M</span>
                <!-- logo for regular state and mobile devices -->
                <span class="logo-lg">multipublicador.<b>grupomontalt</b>.com</span>
            </a>
            <!-- Header Navbar: style can be found in header.less -->
            <nav class="navbar navbar-static-top">
                <!-- Sidebar toggle button-->
                <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
                    <span class="sr-only">Toggle navigation</span>
                </a>

                <div class="navbar-custom-menu">
                    <ul class="nav navbar-nav">

                        <!-- User Account: style can be found in dropdown.less -->
                        <li class="dropdown user user-menu">
                            <a href="#" class="dropdown-toggle" >
                                <span class="hidden-xs">{{ $store.state.app.session.username }}</span>
                            </a>
                        </li>
                        <!-- Control Sidebar Toggle Button -->
                        <router-link tag="li" to="/logout">
                            <a><i class="fa fa-power-off"></i></a>
                        </router-link>
                    </ul>
                </div>
            </nav>
        </header>
        <!-- Left side column. contains the logo and sidebar -->
        <aside class="main-sidebar">
            <!-- sidebar: style can be found in sidebar.less -->
            <section class="sidebar">

                <!-- sidebar menu: : style can be found in sidebar.less -->
                <ul class="sidebar-menu">
                    <li class="header" v-if="$store.getters['app/hasRole']('ROLE_SHOW_TIMELINE') || $store.getters['app/hasRole']('ROLE_SHOW_DASHBOARD') || $store.getters['app/hasRole']('ROLE_SHOW_PROMOTIONS')">GENERAL</li>
                    <router-link tag="li" to="/dashboard" activeClass="active" v-if="$store.getters['app/hasRole']('ROLE_SHOW_DASHBOARD')">
                        <a>
                            <i class="fa fa-area-chart"></i><span>Dashboard</span>
                        </a>
                    </router-link>
                    <router-link tag="li" to="/timeline" activeClass="active" v-if="$store.getters['app/hasRole']('ROLE_SHOW_TIMELINE')">
                        <a>
                            <i class="fa fa-clock-o"></i><span>Timeline</span>
                        </a>
                    </router-link>
                    <router-link tag="li" to="/promotions" activeClass="active" v-if="$store.getters['app/hasRole']('ROLE_SHOW_PROMOTIONS')">
                        <a>
                            <i class="fa fa-rocket"></i><span>Promociones</span>
                        </a>
                    </router-link>
                    <li class="header"  v-if="$store.getters['app/hasRole']('ROLE_CMS_SEARCH_VEHICLES') || $store.getters['app/hasRole']('ROLE_CMS_CREATE_VEHICLES')">VEHÍCULOS</li>
                    <router-link tag="li" to="/cars/search" activeClass="active" v-if="$store.getters['app/hasRole']('ROLE_CMS_SEARCH_VEHICLES')">
                        <a>
                            <i class="fa fa-search"></i><span>Listado de vehículos</span>
                        </a>
                    </router-link>
                    <router-link tag="li" to="/cars/create" activeClass="active" v-if="$store.getters['app/hasRole']('ROLE_CMS_CREATE_VEHICLES')">
                        <a>
                            <i class="fa fa-edit"></i><span>Alta de vehículos</span>
                        </a>
                    </router-link>
                    <li class="header" v-if="$store.getters['app/hasRole']('ROLE_CMS_SEO')">SEO</li>
                    <router-link tag="li" to="/seo/tags" activeClass="active"  v-if="$store.getters['app/hasRole']('ROLE_CMS_SEO')">
                        <a>
                            <i class="fa fa-tags"></i> <span>Tags para descripciones</span>
                        </a>
                    </router-link>
                </ul>
            </section>
            <!-- /.sidebar -->
        </aside>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <router-view :key="$route.fullPath"></router-view>
        </div>
        <!-- /.content-wrapper -->
        <footer class="main-footer">
            <div class="pull-left">
                <b>Version</b> {{ version }} (Build {{ build }}) | <strong>Copyright &copy; 2018 <a href="https://www.grupomontalt.com">Grupo Montalt S.L.</a>.</strong> Todos
                los derechos reservados.
            </div>
        </footer>
    </div>
</template>

<script>
import BtnGroupWrapper from '@/components/custom/BtnGroupWrapper'
export default {
  name: 'MainPageComponent',
  data () {
    return {
      version: process.env.VERSION,
      build: process.env.BUILD
    }
  },
  components: {BtnGroupWrapper}
}
</script>

<style lang="scss" scoped>
    .logo-lg {
        font-size: 0.7em;
    }

    .wrapper {
        min-height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/MainPageComponent.vue